import * as ReactDOM from 'react-dom/client';
import { setupHistoryPolyfills } from '@pcmp/react-providers';
import initI18n from '@/lib/initializers/i18n';
import { App } from '@/app/app';
import '@/styles';

initI18n();
setupHistoryPolyfills();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container not found');
}

ReactDOM.createRoot(container).render(<App />);
